import { Action, createReducer, on } from '@ngrx/store'
import { initialCompanySettingsState, CompanySettingsState } from '../state/company-settings.state'
import { loadCompanySettingsSuccess } from '../action/company-settings.action'
import { initialize_success } from '../action/initialize.action'
import { update_settings_success_action } from '../action/settings.action'

export function companySettingsReducer(state: CompanySettingsState, action: Action) {
  return _companySettingsReducer(state, action)
}

const _companySettingsReducer = createReducer(
  initialCompanySettingsState,
  on(initialize_success, (state, { initializeData }) => ({
    ...state,
    loaded: true,
    enabledModules: initializeData.enabledModules ?? [],
    enabledCategories: initializeData.enabledCategories ?? []
  })),
  on(loadCompanySettingsSuccess, (state, { enabledModules, enabledCategories }) => ({
    ...state,
    loaded: true,
    enabledModules,
    enabledCategories
  })),
  on(update_settings_success_action, (state, { companySettingPreferences }) => ({
    ...state,
    enabledModules: companySettingPreferences?.modules ?? state.enabledModules
  }))
)
